import React from 'react';
import { motion } from 'framer-motion';
export function BrainDiagram() {
  const pathVariants = {
    hidden: {
      pathLength: 0,
      opacity: 0
    },
    visible: {
      pathLength: 1,
      opacity: 1,
      transition: {
        duration: 1.8,
        ease: 'easeInOut'
      }
    }
  };
  const nodeVariants = {
    hidden: {
      scale: 0,
      opacity: 0
    },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.5,
        delay: 1.2
      }
    }
  };
  const labelVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        delay: 1.6
      }
    }
  };
  // Inputs (left side)
  const inputs = [{
    y: 150,
    label: 'GIT / COMMITS',
    sub: 'Repos'
  }, {
    y: 300,
    label: 'CI / CD RUNS',
    sub: 'Build signals'
  }, {
    y: 450,
    label: 'JIRA / LINEAR',
    sub: 'Tickets'
  }];
  // Outputs (right side)
  const outputs = [{
    y: 150,
    label: 'CURSOR / COPILOT',
    sub: 'Context'
  }, {
    y: 300,
    label: 'DEVIN / AGENTS',
    sub: 'Orchestration'
  }, {
    y: 450,
    label: 'ENGINEERING OPS',
    sub: 'Insights'
  }];
  return <div className="w-full" data-id="element-34">
      <svg viewBox="0 0 1400 600" className="w-full h-auto" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" data-id="element-35">
        {/* Incoming Signal Lines (Left → Center) */}
        {inputs.map((node, i) => <motion.path key={`in-${i}`} variants={pathVariants} d={`M 380 ${node.y} C 520 ${node.y}, 580 300, 640 300`} stroke="white" strokeWidth="1" strokeDasharray="4 4" strokeOpacity="0.7" data-id="element-36" />)}

        {/* Outgoing Decision Lines (Center → Right) */}
        {outputs.map((node, i) => <motion.path key={`out-${i}`} variants={pathVariants} d={`M 760 300 C 820 300, 880 ${node.y}, 1020 ${node.y}`} stroke="white" strokeWidth="1" strokeOpacity="0.9" data-id="element-37" />)}

        {/* Central Brain — Waydev Node */}
        <motion.circle variants={nodeVariants} cx="700" cy="300" r="80" fill="black" stroke="white" strokeWidth="2" data-id="element-38" />
        <motion.circle variants={nodeVariants} cx="700" cy="300" r="95" stroke="white" strokeWidth="1" strokeDasharray="2 6" strokeOpacity="0.5" className="origin-center [transform-box:fill-box] animate-[spin_30s_linear_infinite]" style={{
        transformOrigin: '700px 300px'
      }} data-id="element-39" />
        <motion.circle variants={nodeVariants} cx="700" cy="300" r="115" stroke="white" strokeWidth="1" strokeOpacity="0.2" data-id="element-40" />

        {/* Center text inside the node */}
        <motion.text variants={labelVariants} x="700" y="298" textAnchor="middle" fill="white" fontSize="22" fontWeight="700" letterSpacing="-0.02em" data-id="element-41">
          waydev
        </motion.text>
        <motion.text variants={labelVariants} x="700" y="320" textAnchor="middle" fill="#9ca3af" fontSize="10" letterSpacing="0.2em" data-id="element-42">
          MEMORY LAYER
        </motion.text>

        {/* Left Input Nodes + Labels */}
        {inputs.map((node, i) => <g key={`input-group-${i}`} data-id="element-43">
            <motion.circle variants={nodeVariants} cx="380" cy={node.y} r="6" fill="white" data-id="element-44" />
            <motion.text variants={labelVariants} x="355" y={node.y + 4} textAnchor="end" fill="white" fontSize="13" fontWeight="500" letterSpacing="0.15em" data-id="element-45">
              {node.label}
            </motion.text>
            <motion.text variants={labelVariants} x="355" y={node.y + 22} textAnchor="end" fill="#6b7280" fontSize="11" data-id="element-46">
              {node.sub}
            </motion.text>
          </g>)}

        {/* Right Output Nodes + Labels */}
        {outputs.map((node, i) => <g key={`output-group-${i}`} data-id="element-47">
            <motion.rect variants={nodeVariants} x="1014" y={node.y - 6} width="12" height="12" fill="white" data-id="element-48" />
            <motion.text variants={labelVariants} x="1050" y={node.y + 4} textAnchor="start" fill="white" fontSize="13" fontWeight="500" letterSpacing="0.15em" data-id="element-49">
              {node.label}
            </motion.text>
            <motion.text variants={labelVariants} x="1050" y={node.y + 22} textAnchor="start" fill="#6b7280" fontSize="11" data-id="element-50">
              {node.sub}
            </motion.text>
          </g>)}

        {/* Section captions */}
        <motion.text variants={labelVariants} x="200" y="60" fill="#6b7280" fontSize="11" letterSpacing="0.3em" data-id="element-51">
          SIGNALS IN →
        </motion.text>
        <motion.text variants={labelVariants} x="1200" y="60" fill="#6b7280" fontSize="11" letterSpacing="0.3em" textAnchor="end" data-id="element-52">
          → INTELLIGENCE OUT
        </motion.text>
      </svg>
    </div>;
}